import rebrand from '../../../config/rebrand';

export const themeList = (state, rootState) => {
  const boxFormat = rootState.boxFormat;
  return state.list.filter(theme => theme.format.includes(boxFormat));
};

export const themeActive = state => state.active;
export const themeActiveStyles = state => {
  if (!state.active || !state.active.slug) {
    return '';
  }

  return `${rebrand.urls.THEME_CDN_URI}/themes/${state.active.slug}/main.css`;
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/theme/getters.js
 **/